import {Component, Fragment, h} from "preact";
import {AppPage} from "../_common/components/app-page";
import {connect} from "react-redux";
import {t} from '../_i18n';
import {C, F, FR, E, CF, RE, R} from "../_common/layout";
import {CompanyUser} from "../_api";
import {Form as FinalForm} from "react-final-form";
import {FormField, SubmitButtonRow} from "../_common/forms/components/components";
import {savePassword} from "../_rx/jobs/actions";
import {toastService} from "../_services/toast-service";
import {Helmet} from "react-helmet";
import {USER_CHANGE_PASSWORD_TITLE_PAGE, USER_CHANGE_PASSWORD_TITLE} from "../constants";
import AlertBox from "../_common/components/AlertBox/AlertBox";

type Props = {loggedUser:CompanyUser, savePassword:Function, history:any};


class View extends Component<Props,{}> {


    async onSubmit({new_password, new_password_repeat, old_password}:any){
        if(new_password!=new_password_repeat) return "Deben coincidir";

        try {
            await this.props.savePassword(new_password, old_password)
            } catch (e:any) {
            toastService.showToast({message:t("No se ha podido cambiar la contraseña"), type:'danger'});
        }


        this.props.history.push('/user');
    }

    render({ loggedUser, history }:Props) {

        if(!loggedUser) return null;

        return (
            <Fragment>
                <Helmet>
                    <title>{USER_CHANGE_PASSWORD_TITLE_PAGE}</title>
                </Helmet>
                <h1 className='hero'></h1>
                <FinalForm
                onSubmit={(data:any)=>this.onSubmit(data)} initialValues={{}}
                render={({handleSubmit,  submitting, submitErrors, submitFailed}:any)=>
                    <form className='form' action="" onSubmit={handleSubmit}  noValidate>
                        <CF className='max-width'>
                            <FR>
                                <div className="col-100 sm-col-50">
                                    <FormField label={'Password actual'} name="old_password" type="password" required />
                                </div>
                            </FR>
                            <FR>
                                <div className="col-100 sm-col-50">
                                    <FormField label={'Nuevo'} name="new_password" type="password" required />
                                </div>
                                <div className="col-100 sm-col-50">
                                    <FormField label={'Repetir'} name="new_password_repeat" type="password" required />
                                </div>
                            </FR>
                            {submitErrors && <FR><div className="col-100"><div className="col-100"><AlertBox type='warning'>{submitErrors}</AlertBox></div></div></FR>}

                            <SubmitButtonRow disabled={submitting} onCancel={()=>history.push('/user')}/>
                        </CF>

                    </form>}/>
            </Fragment>
        );
    }
}

const ConnectedView: any = connect(
    ({auth:{loggedUser}}:any)=>({loggedUser}), {savePassword})(View as any);

export default ({history}:any) =>
    <AppPage
        name="user-password-change"
        title={t(USER_CHANGE_PASSWORD_TITLE)}
        subtitle=""
        className="max-width">
        <ConnectedView history={history} />

    </AppPage>
;
